/**
 * Merge quick-created values into the values coming from the mapping payload,
 * deduplicated by `key`: the backend maps values asynchronously, so a refetch
 * may or may not already include the created values.
 */
export default function mergeOptionValues(optionValues, createdOptionValues, key = 'id') {
    const merged = [...(optionValues ?? [])];

    (createdOptionValues ?? []).forEach((created) => {
        if (!merged.some((optionValue) => optionValue[key] === created[key])) {
            merged.push(created);
        }
    });

    return merged;
}
